import { requst } from '../config'

// 查询分页数据
export const getLogSettingDictPageApi = params => {
    let url,
        query = ''
    const paramsList = Object.keys(params)
    paramsList.forEach(item => {
        if (Array.isArray(params[item])) {
            let arrayStr = ''
            for (let i = 0; i < params[item].length; i++) {
                arrayStr += `&dictTypes[${i}]=${params[item][i]}`
            }
            query += encodeURI(arrayStr)
        } else {
            query += `&${item}=${params[item]}`
        }
    })
    const result = query.slice(1)
    url = `/system/dict/type/list?` + result
    return requst.get(url)
}

// 查询分页数据2
export const getLogSettingDictDetialApi = params => {
    let url,
        query = ''
    const paramsList = Object.keys(params)
    paramsList.forEach(item => {
        if (Array.isArray(params[item])) {
            let arrayStr = ''
            for (let i = 0; i < params[item].length; i++) {
                arrayStr += `&dictTypes[${i}]=${params[item][i]}`
            }
            query += encodeURI(arrayStr)
        } else {
            query += `&${item}=${params[item]}`
        }
    })
    const result = query.slice(1)
    url = `/system/dict/data/tree?` + result
    return requst.get(url)
}

// 获取某个字典详情
export const getDictDetialApi = dictCode => {
    const url = `/system/dict/data/${dictCode}`
    return requst.get(url)
}

// 删除字典
export const deleteDictApi = dictCode => {
    const url = `/system/dict/data/${dictCode}`
    return requst.delete(url)
}

// 复制
export const postCopyDictApi = params => {
    const url = `/system/dict/data/${params.currentId}/copy/${params.targetId}`
    return requst.post(url)
}

// 修改字典状态
export const putDictStatusApi = params => {
    const url = `/system/dict/data/changeStatus/${params.dictCode}/${params.status}`
    return requst.put(url)
}

// 排序
export const putDictEditSortApi = params => {
    const url = `/system/dict/data/editSort`
    return requst.put(url, params)
}

// 新增字典前，获取内置码
export const getEditDictCodeApi = (dictCode, dictType,projectId) => {
    const url = `/system/dict/data/generateDictValue/${dictType}/${dictCode}/${projectId}`
    return requst.get(url)
}

// 新增或修改字典详情
export const postEditDictDataApi = (params, modalAddNew) => {
    const url = `/system/dict/data`
    if (modalAddNew) {
        return requst.post(url, params)
    } else {
        return requst.put(url, params)
    }
}

// 获取字典同步信息
export const getDictSyncInfoApi = (sourceId, dictTypes) => {
    const url = `/system/dict/data/getDictSyncInfo?sourceId=${sourceId}&dictTypesStr=${dictTypes}`
    return requst.get(url)
}

// 同步字典数据
export const postSyncDictDataApi = syncDictData => {
    const url = `/system/dict/data/syncDictData`
    return requst.post(url, syncDictData)
}

// 删除项目字典数据
export const deleteDictDataApi = projectId => {
    const url = `/system/dict/data/deleteDictDataByProjectId?projectId=${projectId}`
    return requst.delete(url)
}